module.exports = __webpack_public_path__ + "img/5-4.6f073b14.png";